import { AbstractMesh, Vector3 } from '@babylonjs/core';
import { ObstacleDistributionConfig } from '../ObstacleGenerator';
import { AbstractMeshBehavior } from './AbstractMeshBehavior';

export abstract class ObstacleBehavior extends AbstractMeshBehavior {
  protected pathIndex: number;
  protected startPosition: Vector3;
  protected startRotation: Vector3 = Vector3.Zero();
  protected startScale: Vector3 = Vector3.One();
  protected config: ObstacleDistributionConfig;

  constructor(name: string, startPosition: Vector3, pathIndex: number, config: ObstacleDistributionConfig) {
    super(name);
    this.pathIndex = pathIndex;
    this.startPosition = startPosition.clone();
    this.config = config;
  }

  attach(mesh: AbstractMesh): void {
    super.attach(mesh);
    if (mesh.rotationQuaternion) {
      this.startRotation = mesh.rotationQuaternion.toEulerAngles();
    } else {
      this.startRotation = mesh.rotation.clone();
    }
    this.startScale = mesh.scaling.clone();
  }

  initSound() {
    if (this.config.sound) {
      this.setSound(this.config.sound);
    }
  }

  abstract update(deltaTime: number): void;

  clone(): ObstacleBehavior {
    throw new Error('Clone not implemented');
  }

  /**
   * Get distance to player
   */
  protected getPlayerDistance(): number {
    if (!this.level?.player) {
      return Infinity;
    }
    return Vector3.Distance(this.mesh.position, this.level.player.getPosition());
  }

  /**
   * Get distance to player using world-space position.
   * Note: mesh.position is LOCAL when the mesh has a parent (common in glTF models).
   */
  protected getAbsolutePlayerDistance(): number {
    if (!this.level?.player) {
      return Infinity;
    }
    return Vector3.Distance(this.mesh.getAbsolutePosition(), this.level.player.getPosition());
  }

  /**
   * Face toward a target position (Y axis rotation only)
   */
  protected lookAt(target: Vector3): void {
    const direction = target.subtract(this.mesh.position);
    direction.y = 0; // Keep on horizontal plane
    if (direction.length() > 0.01) {
      const angle = Math.atan2(direction.x, direction.z);
      this.mesh.rotation.y = angle;
    }
  }
}
